import { orchestrator } from 'satcheljs';
import { connectedAccountDisconnected } from 'owa-accounts-service';
import removeMergedViewAvailabilityAccount from '../utils/removeMergedViewAvailabilityAccount';
import { getMergeViewEnabledAccount } from '../selectors/getMergeViewEnabledAccount';

orchestrator(connectedAccountDisconnected, async ({ primarySmtpAddress }) => {
    if (getMergeViewEnabledAccount() === primarySmtpAddress) {
        removeMergedViewAvailabilityAccount();
    }
});
